module.exports = "<tags-page></tags-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/tags.html
// module id = 1886
// module chunks = 0